import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../../../app-routing.module';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Angular2SocialLoginModule } from 'angular2-social-login';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ScriptHackModule } from '../script-hack/script-hack.module';
import { BuzzleadComponent } from './buzzlead.component';

@NgModule({
    declarations: [
        BuzzleadComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        HttpModule,
        HttpClientModule,
        Angular2SocialLoginModule,
        AppRoutingModule,
        ScriptHackModule
    ],
    providers: [],
    bootstrap: [],
    exports: [
        BuzzleadComponent
    ]
})
export class BuzzleadModule {}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/shared/components/buzzlead/buzzlead.module.ts